<template>
	<el-select
		ref="input"
		class="input-llood-select"
		no-match-text="No se han encontrado coincidencias"
		no-data-text="Sin datos"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
		@focus="onFocus"
		filterable 
	>

		<el-option
			v-for="item in list"
			:key="item.value"
			:label="item.label"
			:value="item.value"
			:disabled="item.disabled || false"
		/>

	</el-select>
</template>

<script>
	export default {
		name: 'InputLloodSelect',
		props: {
			value: {
				default: ''
			}
		},
		data () {
			return {
				list: []
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { 
					this.$emit('input', val) 
					this.$emit('save', val) 
				}

			}

		},
		created () {

			this.list = this.options

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			onFocus() {

				if (!this.remote) return
				
				this.remoteMethod()

			}
		}
	}
</script>
